import { render } from "./OnlineCompletePage.vue?vue&type=template&id=73c7a4b4&scoped=true&ts=true"
import script from "./OnlineCompletePage.vue?vue&type=script&lang=ts"
export * from "./OnlineCompletePage.vue?vue&type=script&lang=ts"

import "./OnlineCompletePage.vue?vue&type=style&index=0&id=73c7a4b4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1361425700/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c7a4b4"]])

export default __exports__